var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{class:_vm.computedClass,style:(_vm.placeholderStyle)},[(_vm.showMoney)?_vm._t("default"):[_vm._v("​")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }